export default __webpack_public_path__ + "88558c43b572d7c8e3cf976fa9bdeb3c.png";